import React from "react";

import Text from "src/components/text";

import { getAuthorName } from "src/services/reports.service";
import { formatTimespent } from "src/services/reports.service";

import { Asset } from "src/types/assets";
import { Analytics } from "src/types/reports";

import styles from "./popularAssetCard.module.scss";

export interface AssetCardProps {
  item: {
    asset: Asset;
    analytics: Analytics;
  };
}

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

const PopularAssetCard: React.FC<AssetCardProps> = ({ item }) => {
  const { asset, analytics } = item;

  return (
    <a
      href={`/assets/${asset.id}?source=reports`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.linkWrapper}
    >
      <div className={styles.card}>
        <img
          src={asset.icon?.thumbnail || DefaultAssetIcon}
          alt={asset.name}
          className={styles.thumbnail}
        />
        <div className={styles.content}>
          <Text text={asset.name || ""} lines={1} className={styles.title} />
          <div className={styles.metrics}>
            <span>{analytics.views || 0} Views</span>
            <span>
              {formatTimespent(analytics.avgTimeSpent || 0)} Avg Time{" "}
            </span>
            <span>{analytics.downloads || 0} Downloads</span>
          </div>
          <div className={styles.meta}>
            Author:{" "}
            <Text
              text={asset.author ? getAuthorName(asset.author) : ""}
              lines={1}
              className={styles.author}
            />
          </div>
        </div>
      </div>
    </a>
  );
};

export default PopularAssetCard;
